import { createSlice } from '@reduxjs/toolkit';

import * as TokenUserIdRepository from '@/modules/log/infraestructure/TokenUserIdRepository';

interface LogState {
  tokenUserId: string | null;
  isLoading: boolean;
}

const initialState: LogState = {
  tokenUserId: null,
  isLoading: false
};

const TokenUserIdSlice = createSlice({
  name: 'log',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(TokenUserIdRepository.getTokenUserIdAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        TokenUserIdRepository.getTokenUserIdAsync.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.tokenUserId = action.payload.tokenUserId;
        }
      )
      .addCase(TokenUserIdRepository.getTokenUserIdAsync.rejected, (state) => {
        state.isLoading = false;
        state.tokenUserId = null;
      })
});

export const tokenUserIdReducer = TokenUserIdSlice.reducer;
